import { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import UserService from "../services/EmployeeService";
import RoleMasterService from "../services/RoleMasterService";
import MasterLocationService from "../services/MasterLocationService";
import Breadcrumb from "../components/Breadcrumb";
import StorageService from "../services/StorageService";
import utility from "../utils/utility";
import { configSettings } from "../config/configSettings";
import { useParams } from "react-router-dom";
import MessageDialog from "../components/MessageDialog";

export default function AddEmployee() {
  const [companyName, setCompanyName] = useState("Default Company");
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [roles, setRoles] = useState([]);
  // const messageTimer = useRef(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const [pageLoading, setPageLoading] = useState(!!id);


  const [profilePreview, setProfilePreview] = useState(null);
  const [profilePreviewOld, setProfilePreviewOld] = useState(null);

  const [managers, setManagers] = useState([]);
  const [customizeLoginId, setCustomizeLoginId] = useState(false);

  const { register, handleSubmit, reset, setValue, setError, watch, formState: { errors } } = useForm({ mode: "onChange" });


  const loggedUser = StorageService.loginData();
  const [previewOld, setPreviewOld] = useState(null);

  // useEffect(() => {
  //   const name = localStorage.getItem("selectedCompanyId");
  //   if (name) setCompanyName(name);

  //   // Fetch roles dynamically from backend
  //   const fetchRoles = async () => {
  //     try {
  //       const res = await RoleMasterService.getAllRoles();
  //       if (res.status) setRoles(res.data);
  //     } catch (error) {
  //       console.error("Error fetching roles:", error);
  //     }
  //   };
    

  //   const fetchManagers = async (companyId) => {
  //     try {
  //       const res = await UserService.getReportingManagers(companyId);
  //       if (res.status && Array.isArray(res.data)) {
  //         setManagers(res.data);
  //       } else {
  //         setManagers([]);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching managers:", error);
  //     }
  //   };

  //   const fetchCountries = async () => {
  //     try {
  //       const countryData = await MasterLocationService.getAllCountries();
  //       setCountries(countryData || []);
  //     } catch (error) {
  //       console.error("Error fetching countries:", error);
  //     }
  //   };

  //   //  Updated logic for loading edit data
  //   const loadEditData = async () => {
  //     if (!id) return;

  //     try {
  //       setPageLoading(true); // 🔄 START LOADING

  //       const data = await UserService.getById(id);

  //       const mappedData = {
  //         firstName: data.firstName || "",
  //         lastName: data.lastName || "",
  //         loginId: data.loginId || "",
  //         mobileNo: data.mobileNo || "",
  //         emailId: data.emailId || "",
  //         employeeCode: data.employeeCode || "",
  //         gender: data.gender || "",
  //         roleId: data.roleId || "",
  //         address: data.address || "",
  //         landmark: data.landmark || "",
  //         zip: data.zip || "",
  //         doj: data.doj ? data.doj.split("T")[0] : "",
  //         dor: data.dor ? data.dor.split("T")[0] : "",
  //         country: data.countryId || "",
  //         state: data.state || "",
  //         city: data.city || "",
  //         managerId: data.managerId || "",
  //       };

  //       reset(mappedData);

  //       // Image preview
  //       if (data.profilePic) {
  //         const fileName = data.profilePic.split("/").pop();
  //         setProfilePreview(
  //           `${configSettings.mediaURL}/get/employee/${fileName}`
  //         );
  //         setProfilePreviewOld(fileName);
  //         setValue("profilePicOld", fileName);
  //       }

  //       // Load states
  //       if (data.countryId) {
  //         const stateList =
  //           await MasterLocationService.getStatesByCountry(data.countryId);
  //         setStates(stateList || []);
  //         setSelectedCountry(data.countryId);
  //       }

  //       // Load cities
  //       if (data.state) {
  //         const cityList =
  //           await MasterLocationService.getCitiesByState(data.state);
  //         setCities(cityList || []);
  //         setSelectedState(data.state);
  //       }

  //       if (data.city) {
  //         setValue("city", data.city);
  //       }

  //     } catch (err) {
  //       console.error("Error loading user:", err);
  //     } finally {
  //       setPageLoading(false); // ✅ STOP LOADING
  //     }
  //   };


  //   const initializeForm = async () => {
  //     await fetchRoles();
  //     await fetchCountries();
  //     await fetchManagers(name);
  //     if (id) await loadEditData();
  //   };

  //   initializeForm();
  // }, []);

  useEffect(() => {
    const activeCompany = StorageService.activeCompany();

    if (activeCompany?.companyName) {
      setCompanyName(activeCompany.companyName);
    }

    const companyId = activeCompany?.companyId;

    const fetchRoles = async () => {
      try {
        const res = await RoleMasterService.getAllRoles();
        if (res.status) setRoles(res.data);
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };

    const fetchManagers = async (companyId) => {
      try {
        const res = await UserService.getReportingManagers(companyId);
        if (res.status && Array.isArray(res.data)) {
          setManagers(res.data);
        } else {
          setManagers([]);
        }
      } catch (error) {
        console.error("Error fetching managers:", error);
      }
    };

    const fetchCountries = async () => {
      try {
        const countryData = await MasterLocationService.getAllCountries();
        setCountries(countryData || []);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    const loadEditData = async () => {
      if (!id) return;

      try {
        setPageLoading(true);

        const data = await UserService.getById(id);

        const mappedData = {
          firstName: data.firstName || "",
          lastName: data.lastName || "",
          loginId: data.loginId || "",
          mobileNo: data.mobileNo || "",
          emailId: data.emailId || "",
          employeeCode: data.employeeCode || "",
          gender: data.gender || "",
          roleId: data.roleId || "",
          address: data.address || "",
          landmark: data.landmark || "",
          zip: data.zip || "",
          doj: data.doj ? data.doj.split("T")[0] : "",
          dor: data.dor ? data.dor.split("T")[0] : "",
          country: data.countryId || "",
          state: data.state || "",
          city: data.city || "",
          managerId: data.managerId || "",
        };

        reset(mappedData);
        setSelectedCountry(data.countryId || "");

        if (data.profilePic) {
          const fileName = data.profilePic.split("/").pop();
          setProfilePreview(`${configSettings.mediaURL}/get/employee/${fileName}`);
          setProfilePreviewOld(fileName);
          setValue("profilePicOld", fileName);
        }

        if (data.countryId) {
          const stateList =
            await MasterLocationService.getStatesByCountry(data.countryId);
          setStates(stateList || []);
          setSelectedCountry(data.countryId);
        }

        // if (data.state) {
        //   const cityList =
        //     await MasterLocationService.getCitiesByState(data.state);
        //   setCities(cityList || []);
        //   setSelectedState(data.state);
        // }
        // if (data.state) {
        //   setSelectedState(data.state);   // move this first

        //   const cityList =
        //     await MasterLocationService.getCitiesByState(data.state);
        //   setCities(cityList || []);
        // }

        // if (data.city) {
        //   setValue("city", data.city);
        // }
        if (data.state) {
          setSelectedState(data.state);

          const cityList =
            await MasterLocationService.getCitiesByState(data.state);
          setCities(cityList || []);

          //  FIX: set city AFTER cities loaded
          setValue("city", data.city);
        }

      } catch (err) {
        console.error("Error loading user:", err);
      } finally {
        setPageLoading(false);
      }
    };

    const initializeForm = async () => {
      await fetchRoles();
      await fetchCountries();
      if (companyId) await fetchManagers(companyId);
      if (id) {
        await loadEditData();
      } else if (companyId) {
        try {
          const resCode = await UserService.getNextEmployeeCode(companyId);
          if (resCode && resCode.status) {
            setValue("employeeCode", resCode.data);
            setValue("loginId", resCode.data);
          }
        } catch (err) {
          console.error("Error loading next employee code:", err);
        }
      }
    };

    initializeForm();
  }, []);


  useEffect(() => {
    if (!id) {
      const today = new Date().toISOString().split("T")[0];
      setValue("doj", today);
    }
  }, [id, setValue]);


  const handleCountryChange = async (e) => {
    const countryId = e.target.value;
    setSelectedCountry(countryId);
    setSelectedState("");
    setCities([]);
    setValue("state", "");
    setValue("city", "");

    if (countryId) {
      const statesData = await MasterLocationService.getStatesByCountry(
        countryId
      );
      setStates(statesData || []);
    } else {
      setStates([]);
    }
  };

  // Handle State Change → Fetch Cities
  const handleStateChange = async (e) => {
    const stateId = e.target.value;
    setSelectedState(stateId);
    setValue("city", "");

    if (stateId) {
      const citiesData = await MasterLocationService.getCitiesByState(stateId);
      setCities(citiesData || []);
    } else {
      setCities([]);
    }
  };

  //Message popup handlers
  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) {
  //     clearTimeout(messageTimer.current);
  //     messageTimer.current = null;
  //   }
  // };

  // const handleImageUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   const reader = new FileReader();
  //   reader.onloadend = () => {
  //     setPreview(reader.result);           // preview for UI
  //     setValue("profilePic", reader.result); // send base64 to backend
  //   };
  //   reader.readAsDataURL(file);
  // };
  const handleFileUpload = (e) => {
    utility.readFile(e, setProfilePreview, "profilePic");
    // utility.readFile automatically sets base64 into form data using setValue
  };

  // Save or Update user
  const onSubmit = async (data) => {
    const activeCompany = StorageService.activeCompany();
    data.companyId = activeCompany.companyId;
    data.createdBy = loggedUser.employeeId;
    data.updatedBy = loggedUser.employeeId;

    if (!id) {
      data.useEmployeeCodeAsLoginId = !customizeLoginId;
    }

    if (profilePreview && profilePreview.startsWith("data:image")) {
      data.profilePic = profilePreview; // new image (base64)
    } else {
      data.profilePic = ""; // no new image
    }

    // Always send old image name
    if (id) {
      data.profilePicOld = profilePreviewOld || "";
    }

    try {
      setLoading(true);
      let response;
      data.managerId = data.managerId || null;
      // API call based on add/edit mode
      if (id) {
        response = await UserService.updateUser(id, data);
      } else {
        response = await UserService.createUser(data);
      }

      console.log(" API RESPONSE:", response);

      // Handle backend validations when HTTP response status = 200 but status=false
      if (response && response.status === false) {
        if (response.field && response.message) {
          showMessage(response.message, "error");
          setError(response.field, { message: response.message });
        } else {
          showMessage("Failed to save user!", "error");
        }
        return;
      }

      // Success case
      showMessage(
        id ? "User updated successfully!" : "User added successfully!",
        "success"
      );

      // localStorage.removeItem("editItem");
      setTimeout(() => navigate("/cpnl/users/view"), 1000);

    } catch (err) {
      console.error(" Error saving user:", err);

      // Handle backend validation when HTTP STATUS = 400 (axios throws error)
      if (err.response && err.response.data) {
        const errorData = err.response.data;

        if (errorData.field && errorData.message) {
          showMessage(errorData.message, "error");
          setError(errorData.field, { message: errorData.message });
          return;
        }
      }

      // Default fallback error
      showMessage("Something went wrong while saving the user!", "error");

    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    // localStorage.removeItem("editItem");
    navigate("/cpnl/users/view");
  };

  return (
    <>
      <Breadcrumb
        pageTitle="Manage Employee"
        secondTitle="Employee Management"
      ></Breadcrumb>
      {/* {message && (
        <div
          className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
            } d-flex justify-content-between align-items-center w-100 mb-3 p-2`}
          style={{ borderRadius: "5px" }}
        >
          <span>{message}</span>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeMessage}
            style={{ fontSize: "0.8rem" }}
          ></button>
        </div>
      )} */}
      
        <MessageDialog
          message={message}
          type={msgType}
          setMessage={setMessage}
          setMsgType={setMsgType}
        />
      
      <div className="row">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="card bg-white shadow-sm">
              <div className="card-header">
                <div className="flex-wrap justify-content-between hstack gap-1">
                  <div class="align-self-center vstack">
                    <h5 className="text-info">General Information</h5>
                  </div>
                </div>
              </div>
            <div className="card-body position-relative">
              {pageLoading && (
                <div
                  className="position-absolute top-0 start-0 w-100 h-100
                 d-flex justify-content-center align-items-center"
                  style={{
                    background: "rgba(255,255,255,0.7)",
                    zIndex: 10,
                    // paddingTop: "1px",
                  }}
                >
                  <div className="spinner-border text-primary" role="status" />
                </div>
              )}
              <div className={pageLoading ? "opacity-50 pointer-events-none" : ""}>
                <div className="row">
                  {/* First Name */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      First Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${errors.firstName ? "is-invalid" : ""
                        }`}
                      {...register("firstName", { required: "Required" })}
                    />
                    {errors.firstName && (
                      <small className="text-danger">
                        {errors.firstName.message}
                      </small>
                    )}
                  </div>

                  {/* Last Name */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Last Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${errors.lastName ? "is-invalid" : ""
                        }`}
                      {...register("lastName", { required: "Required" })}
                    />
                    {errors.lastName && (
                      <small className="text-danger">
                        {errors.lastName.message}
                      </small>
                    )}
                  </div>

                  {/* Gender */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Gender <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      {...register("gender", { required: "Required" })}
                    >
                      <option value="">Select Gender</option>
                      {["Male", "Female", "Other"].map((g) => (
                        <option key={g} value={g}>
                          {g}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Profile Picture */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Profile Picture</label>
                    <input
                      type="file"
                      accept="image/*"
                      className="form-control"
                      onChange={(e) => handleFileUpload(e)}
                    />
                    {profilePreview && (
                      <img
                        src={profilePreview}
                        alt="Profile Preview"
                        className="rounded mt-2"
                        width="120"
                        height="120"
                        style={{ objectFit: "cover", border: "1px solid #ddd" }}
                      />
                    )}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Mobile No <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${errors.mobileNo ? "is-invalid" : ""}`}
                      {...register("mobileNo", {
                        required: "Mobile number is required",
                        pattern: {
                          value: /^[6-9]\d{9}$/,
                          message: "Enter a valid 10-digit mobile number",
                        },
                      })}
                    />
                    {errors.mobileNo && (
                      <small className="text-danger">{errors.mobileNo.message}</small>
                    )}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      e-Mail Id <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className={`form-control ${errors.emailId ? "is-invalid" : ""}`}
                      {...register("emailId", {
                        required: "Email ID is required",
                        pattern: {
                          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                          message: "Enter a valid email address",
                        },
                      })}
                    />
                    {errors.emailId && (
                      <small className="text-danger">{errors.emailId.message}</small>
                    )}
                  </div>
                  {/* {["mobileNo", "emailId"].map((field, idx) => (
                  <div key={idx} className="col-md-6 mb-3">
                    <label className="form-label">
                      {field.includes("mobileNo") ? "Mobile No" : "e-Mail Id"}{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type={field.includes("password") ? "password" : "text"}
                      className={`form-control ${errors[field] ? "is-invalid" : ""
                        }`}
                      {...register(field)}
                    />
                    {errors[field] && (
                      <small className="text-danger">
                        {errors[field].message}
                      </small>
                    )}
                  </div>
                ))} */}

                  {/* Country, State, City */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Country <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      {...register("country", { required: "Required" })}
                      value={watch("country") || ""}
                      onChange={(e) => {
                        setValue("country", e.target.value);
                        handleCountryChange(e);
                      }}
                    >
                      <option value="">Select Country</option>
                      {countries.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.countryName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      State <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      {...register("state", { required: "Required" })}
                      value={selectedState || ""}
                      onChange={(e) => {
                        setValue("state", e.target.value);
                        handleStateChange(e);
                      }}
                      disabled={!watch("country")}
                    >
                      <option value="">Select State</option>
                      {states.map((s) => (
                        <option key={s.id} value={s.id}>
                          {s.stateName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      District <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      {...register("city", { required: "Required" })}
                      value={watch("city") || ""}
                      onChange={(e) => setValue("city", e.target.value)}
                      disabled={!watch("state")}
                    >
                      <option value="">Select District</option>
                      {cities.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.cityName}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Address */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Address</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("address")}
                    />
                  </div>

                  {/* Landmark */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Landmark</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("landmark")}
                    />
                  </div>

                  {/* ZIP */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label">ZIP</label>
                    {/* <input
                      type="text"
                      className="form-control"
                      {...register("zip")}
                    /> */}
                      <input
                        type="text"
                        className={`form-control ${errors.zip ? "is-invalid" : ""}`}
                        {...register("zip", {
                          validate: (value) => {
                            if (!value) return true; // ✅ optional

                            if (!/^[0-9]{6}$/.test(value)) {
                              return "ZIP code must be exactly 6 digits";
                            }

                            return true;
                          },
                        })}
                      />
                    {errors.zip && (
                      <small className="text-danger">{errors.zip.message}</small>
                    )}
                  </div>
                </div>
              </div>
              <div className="card-header">
                <div className="flex-wrap justify-content-between hstack gap-1">
                  <div class="align-self-center vstack">
                    <h5 className="text-info">Employement Information</h5>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  {/* Employee Code */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Employee Code <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("employeeCode")}
                      readOnly
                    />
                  </div>
                 
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Role / Designation <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select"
                        {...register("roleId", { required: "Required" })}
                      >
                        <option value="">Select Role</option>
                        {roles.map((role) => (
                          <option key={role.id} value={role.id}>
                            {role.roleName}
                          </option>
                        ))}
                      </select>
                      {errors.roleId && (
                        <small className="text-danger">Role is required</small>
                      )}
                    </div>
                

                  {/* Reporting Manager (non-mandatory in edit mode) */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Reporting Manager 
                    </label>
                    <select
                      className="form-select"
                      // {...register("managerId", { required: !id ? "Required" : false, })}
                      {...register("managerId")}
                    >
                      <option value="">Select Manager</option>
                      {managers.map((m) => (
                        <option key={m.id} value={m.id}>
                          {m.firstName} {m.lastName} ({m.roleName})
                        </option>
                      ))}
                    </select>
                    {errors.managerId && (
                      <small className="text-danger">managers is required</small>
                    )}
                  </div>
                  {/* DOJ */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Date of Joining <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      className={`form-control ${errors.doj ? "is-invalid" : ""
                        }`}
                      {...register("doj", { required: "Required" })}
                    />
                    {errors.doj && (
                      <small className="text-danger">
                        {errors.doj.message}
                      </small>
                    )}
                  </div>
                  {id && (
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Date of Resignation</label>
                      <input
                        type="date"
                        className="form-control"
                        {...register("dor", {
                          validate: (value) => {
                            if (!id) return true;
                          
                            const doj = new Date(watch("doj"));
                            const dor = new Date(value);

                            if (!value) return true;
                            if (dor <= doj) return "Resignation date must be greater than joining date";
                            return true;
                          },
                        })}
                      />
                      {errors.dor && (
                        <small className="text-danger">
                          {errors.dor.message}
                        </small>
                      )}
                    </div>
                  )}
                </div>
              </div>
              {/* ✅ Show Employment Information section only when adding a new employee */}
                <>
                  <div className="card-header">
                    <div className="flex-wrap justify-content-between hstack gap-1">
                      <div class="align-self-center vstack"><h5 className="text-info">Login Information</h5></div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {/* User ID */}
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          User ID <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.loginId ? "is-invalid" : ""}`}
                          {...register("loginId", { required: "Login ID is required" })} 
                          readOnly={!!id || !customizeLoginId}
                        />
                        {errors.loginId && (
                          <small className="text-danger">
                            {errors.loginId.message}
                          </small>
                        )}
                        {!id && (
                          <div className="form-check mt-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="customizeLoginIdCheckbox"
                              checked={customizeLoginId}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setCustomizeLoginId(checked);
                                if (!checked) {
                                  setValue("loginId", watch("employeeCode"));
                                }
                              }}
                            />
                            <label className="form-check-label" htmlFor="customizeLoginIdCheckbox">
                              Customize User ID (otherwise same as Employee Code)
                            </label>
                          </div>
                        )}
                      </div>
                      {/* Mobile, Email, Password, Confirm Password */}
                      {!id && ["password"].map(
                        (field, idx) => (
                          <div key={idx} className="col-md-6 mb-3">
                            <label className="form-label">
                              {field.includes("password") ? "Password" : ""} <span className="text-danger">*</span>
                            </label>
                            <input
                              type={field.includes("password") ? "password" : "text"}
                              className={`form-control ${errors[field] ? "is-invalid" : ""
                                }`}
                              {...register(field, { required: !id ? "Required" : false })} // required only when adding
                            />
                            {errors[field] && (
                              <small className="text-danger">
                                {errors[field].message}
                              </small>
                            )}
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </>
              <div className="card-footer">
                {/*  Buttons */}
                <button
                  type="submit"
                  className="d-inline-flex btn btn-primary me-2"
                  disabled={loading}
                >
                  <i class="ti ti-circle-check me-1"></i>
                  {loading
                    ? id
                      ? "Updating..."
                      : "Saving..."
                    : id
                      ? "Update"
                      : "Save"}
                </button>
                <button
                  type="button"
                  className="d-inline-flex btn btn-secondary"
                  onClick={handleCancel}
                  disabled={loading}
                >
                  <i class="ti ti-cancel me-1"></i> Cancel
                </button>
              </div>
            </div>
          </div>
          </form>
      </div>
    </>
  );
}
